import axios from 'axios';
import z from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';
import { createValidator } from 'functions/validation/zod';

export interface Response {
	data: ResponseData;
}

const StatusSchema = z.object({
	status: z.string(),
});

const ResponseDataSchema = z.record(StatusSchema);
const validator = createValidator(ResponseDataSchema);

export type ResponseData = z.infer<typeof ResponseDataSchema>;

export async function callApi(): Promise<Optional<ResponseData>> {
	const url: string = `${SERVICEBASEURL.AI}/erp/status/`;
	const response = (await axios.get(url).toOptionalFiltered(validator)).map((x) => x.data);
	return response;
}
